/**
 * Constants for EscalatedQueries page component
 */

// Reuse REGION_OPTIONS and STATUS_CARD_CONFIG from raiseQueryPage
export { REGION_OPTIONS, STATUS_CARD_CONFIG } from './raiseQueryPage';

export const DEFAULT_QUERY_TYPE_OPTIONS = [
  { value: 'General', label: 'General' },
  { value: 'Technical', label: 'Technical' },
  { value: 'Financial', label: 'Financial' },
  { value: 'Operational', label: 'Operational' },
  { value: 'Other', label: 'Other' },
];

export const LIFECYCLE_STATUS_STYLES = {
  escalated: { label: 'Escalated', color: '#d97706' },
  delegated: { label: 'Delegated', color: '#0891b2' },
};
